import { useChartOptions } from "@/chartOptions/ChartOptionsContext";
import { Switch } from "@/components/ui/switch";
import React, { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { ChevronsUpDown } from "lucide-react";

const ChartOptionsSelector = ({ showPowerOffToggle = false }: { showPowerOffToggle?: boolean } = {}) => {

  const [open, setOpen] = useState(false)
  const { showTemperature, setShowTemperature, highlightWeekends, setHighlightWeekends, highlightPowerOff, setHighlightPowerOff } = useChartOptions();

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="whitespace-nowrap inline-flex items-center text-sm transition-colors bg-white text-left font-normal px-2 rounded-md border border-input hover:bg-accent hover:text-accent-foreground cursor-pointer"
        >
          Chart options
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-full p-4 flex flex-col gap-4 text-sm" side="bottom" align="start">
        <div className="flex items-center">
          <Switch
            className="mr-2"
            checked={showTemperature}
            onCheckedChange={(value: boolean) =>
              setShowTemperature(value)
            }
          />
          Show outdoor temperature
        </div>
        <div className="flex items-center">
          <Switch
            className="mr-2"
            checked={highlightWeekends}
            onCheckedChange={(value: boolean) =>
              setHighlightWeekends(value)
            }
          />
          Highlight weekends
        </div>
        {showPowerOffToggle && (
          <div className="flex items-center">
            <Switch
              className="mr-2"
              checked={highlightPowerOff}
              onCheckedChange={(value: boolean) =>
                setHighlightPowerOff(value)
              }
            />
            Highlight "power OFF"
          </div>
        )}
      </PopoverContent>
    </Popover>
  )
}

export default ChartOptionsSelector;